module.exports = __webpack_public_path__ + "static/media/3.438bc430.svg";